<button
  [attr.aria-label]="'navigation.scrollToTop' | cxTranslate"
  class="cx-scroll-to-top-btn"
  (click)="scrollToTop()"
>
  <span aria-hidden="true">
    <cx-icon class="caret-up-icon" [type]="iconTypes.CARET_UP"></cx-icon>
  </span>
</button>
